import { Mail, MapPin, Clock } from "lucide-react"

// Company Information
export const COMPANY_INFO = {
  name: "WeBuyYourWatches",
  legalName: "We Buy Your Watches LLC",
  website: "https://webuyyourwatches.com",
  email: "sell@webuyyourwatches.com",
  phone: "+44 20 7123 4567",
  address: "36 Hatton Garden",
  area: "",
  city: "London",
  postcode: "EC1N 8EB",
  country: "United Kingdom",

  // Business Hours
  hours: {
    weekdays: "Mon-Fri: 9:00 AM - 6:00 PM",
    saturday: "Sat: 10:00 AM - 4:00 PM",
    sunday: "Closed",
    full: "Mon-Fri 9AM-6PM"
  },

  // Legal Document Dates
  privacyPolicyLastUpdated: "January 1, 2024",
  termsLastUpdated: "January 1, 2024",

  // Business Details
  founded: 2004,
  tagline: "Professional watch buying service with Swiss precision",
  description: "We specialize in luxury & vintage timepieces, offering fair valuations & immediate payment.",

  // Credentials
  credentials: {
    bbbRating: "BBB A+ Rating",
    license: "Licensed Dealer",
    insurance: "Fully Insured",
    accredited: "Accredited & Insured"
  }
}

// Navigation Links
export const NAVIGATION_LINKS = [
  { label: "Home", href: "/" },
  { label: "How it Works", href: "/process" },
  { label: "About Us", href: "/about" },
  { label: "Contact", href: "/contact" },
  { label: "Sell Your Watch", href: "/sell" }
]

// Watch Categories/Brands We Buy
export const WATCH_CATEGORIES = [
  { label: "Rolex Watches", href: "/brands/rolex" },
  { label: "Patek Philippe", href: "/brands/patek-philippe" },
  { label: "Audemars Piguet", href: "/brands/audemars-piguet" },
  { label: "Omega Timepieces", href: "/brands/omega" },
  { label: "Cartier Timepieces", href: "/brands/cartier" },
  { label: "Tudor Watches", href: "/brands/tudor" },
  { label: "Breitling Watches", href: "/brands/breitling" },
  { label: "TAG Heuer", href: "/brands/tag-heuer" },
  { label: "IWC Watches", href: "/brands/iwc" },
  { label: "Jaeger-LeCoultre", href: "/brands/jaeger-lecoultre" },
  { label: "Vintage Watches", href: "/categories/vintage" }
]

// Contact Information with Icons
export const CONTACT_INFO = [

  {
    icon: Mail,
    label: "Email",
    value: COMPANY_INFO.email,
    subtitle: "24-hour response guarantee",
    displayValue: COMPANY_INFO.email
  },
  {
    icon: MapPin,
    label: "Location",
    value: COMPANY_INFO.address,
    subtitle: `${COMPANY_INFO.address}, ${COMPANY_INFO.area}, ${COMPANY_INFO.city} ${COMPANY_INFO.postcode}`,
    displayValue: `${COMPANY_INFO.address}`
  },
  {
    icon: Clock,
    label: "Hours",
    value: COMPANY_INFO.hours.weekdays,
    subtitle: COMPANY_INFO.hours.saturday,
    displayValue: COMPANY_INFO.hours.full
  }
]

// Legal Links
export const LEGAL_LINKS = [
  { label: "Privacy Policy", href: "/legal/privacy-policy" },
  { label: "Terms of Service", href: "/legal/terms-and-conditions" },
]

// Watch Brands for Forms - put in alphabetical
export const WATCH_BRANDS = [
  { value: "", label: "Select Brand" },
  { value: "audemars-piguet", label: "Audemars Piguet" },
  { value: "cartier", label: "Cartier" },
  { value: "omega", label: "Omega" },
  { value: "patek-philippe", label: "Patek Philippe" },
  { value: "rolex", label: "Rolex" },
  { value: "richard-mille", label: "Richard Mille" },
  { value: "tudor", label: "Tudor" },
]

// Watch Conditions for Forms
export const WATCH_CONDITIONS = [
  { value: "", label: "Select Condition" },
  { value: "excellent", label: "Excellent - Like new, minimal wear" },
  { value: "very-good", label: "Very Good - Light wear, well maintained" },
  { value: "good", label: "Good - Normal wear, fully functional" },
  { value: "fair", label: "Fair - Heavy wear, may need service" },
  { value: "poor", label: "Poor - Significant damage or not working" }
]

// Expertise Areas
export const EXPERTISE_AREAS = [
  "Rolex & Tudor",
  "Patek Philippe",
  "Audemars Piguet",
  "Omega & Speedmaster",
  "Cartier Timepieces",
  "Vintage Collections"
]

// Why Choose Us Points
export const WHY_CHOOSE_US = [
  "Professional authentication & valuation services",
  "Immediate payment upon agreement",
  "Discreet & secure transactions",
  "20+ years of luxury watch expertise"
]

// Social Media Links (if needed)
export const SOCIAL_MEDIA = {
  facebook: "https://facebook.com/webuyyourwatches",
  instagram: "https://instagram.com/webuyyourwatches",
  twitter: "https://twitter.com/webuywatches",
  linkedin: "https://linkedin.com/company/webuyyourwatches"
}

// SEO Meta Data
export const SEO_DEFAULTS = {
  siteName: COMPANY_INFO.name,
  description: COMPANY_INFO.tagline,
  keywords: "sell watch, buy luxury watches, Rolex buyer, Patek Philippe, Audemars Piguet, watch valuation",
  author: COMPANY_INFO.name,
  type: "website",
  locale: "en_US"
}